














import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

import SelectSimpleText from "../resources/selectSimpleText.vue";
import SelectPlainText from "../resources/selectPlainText.vue";
import SelectCircleText from "../resources/selectCircleText.vue";
import Select3DText from "../resources/select3DText.vue";
import SelectDate from "../resources/selectDate.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
      SelectSimpleText,
      SelectPlainText,
      SelectCircleText,
      Select3DText,
      SelectDate
  }
})
export default class SelectTextBalloon extends Vue {
    @Prop() private userConfigColor! : string;

    select(type : string) {
        this.$emit("select", type);
        this.$emit("close");
    }

    close() {
        this.$emit("close");
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
